import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const discriminatedUnionValidator = ({ discriminator, schemas, requiredError, invalidValueError, }) => {
    return z.discriminatedUnion(discriminator, schemas, {
        error: createErrorHandler(requiredError, invalidValueError),
    });
};
